/* src/app/components/billing/global-ledger/global-ledger-list/global-ledger-list.component.css */
:host {
  --teal-head-text: #00504b;
  --teal-mid: #01796f;
  --teal-pale: #cff1ef;
  --teal-bright: #10b8ad;
  --meta-gray: #454545;
  --lavender-pale: #eeecfd;
  --green: #1e8a4c;
  --green-bg: #e8f6ed;
  --red: #c0392b;
  --red-bg: #fdeceb;
  --blue: #1890ff;
  --blue-bg: #eff6ff;
  --blue-line: #bfdbfe;
  --line: #d9d9d9;
  --line-eee: #eee;
  --disabled: #d9d9d9;
  --mono-font:
    "Cascadia Code",
    "Consolas",
    "Courier New",
    monospace;
}
.gl-head.ppl-container-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.gl-head__titles {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.gl-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: .786rem;
  font-weight: 400;
}
.gl-breadcrumb__link {
  color: var(--teal-mid);
  font-weight: 600;
  text-decoration: none;
}
.gl-breadcrumb__link:hover {
  text-decoration: underline;
}
.gl-breadcrumb__sep,
.gl-breadcrumb__current {
  color: var(--meta-gray);
}
.gl-title {
  margin: 0;
  color: var(--teal-head-text);
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.15;
}
.gl-feedback {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: .857rem;
  font-weight: 700;
  color: var(--green);
  background: var(--green-bg);
  border: 1px solid #b8e2c8;
}
.gl-feedback--error {
  color: var(--red);
  background: var(--red-bg);
  border-color: #f3c2bd;
}
.gl-tabs,
[role=tabpanel],
.gl-filter-card,
.gl-section {
  width: 100%;
  box-sizing: border-box;
}
.gl-tabs {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.gl-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 2.571rem;
  padding: 0 1.143rem;
  border-radius: 8px;
  border: 2px solid #fff;
  background: var(--lavender-pale);
  color: #303030;
  font-size: .929rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color .3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, .06);
}
.gl-tab:hover {
  background: var(--teal-pale);
}
.gl-tab[aria-selected=true] {
  background: var(--teal-bright);
  color: #fff;
  cursor: default;
}
.gl-section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, .1);
  overflow: hidden;
}
.gl-sec-head {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  background: var(--teal-pale);
  border-radius: 8px 8px 0 0;
  flex-wrap: wrap;
}
.gl-sec-head__title {
  margin: 0;
  font-size: 1.071rem;
  font-weight: 700;
  color: var(--teal-head-text);
}
.gl-sec-head__sum {
  margin-left: auto;
  font-size: .857rem;
  color: var(--meta-gray);
  font-weight: 400;
}
.gl-sec-body {
  padding: 16px;
}
.gl-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 2.571rem;
  padding: .571rem .857rem;
  border-radius: 8px;
  font-size: .857rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color .3s ease;
}
.gl-btn--ghost {
  background: #fff;
  border: 1px solid var(--line);
  color: #303030;
}
.gl-btn--ghost:hover:not(:disabled) {
  background: #303030;
  color: #fff;
}
.gl-btn--primary {
  background: #c7bcff;
  border: 2px solid #3d0072;
  color: #303030;
}
.gl-btn--primary:hover:not(:disabled) {
  background: #303030;
  color: #fff;
}
.gl-btn--danger {
  background: #fff;
  border: 1px solid #f3c2bd;
  color: var(--red);
}
.gl-btn--danger:hover:not(:disabled) {
  background: var(--red);
  border-color: var(--red);
  color: #fff;
}
.gl-btn:disabled {
  background: var(--disabled);
  border-color: var(--line);
  color: #8a8a8a;
  cursor: not-allowed;
}
.gl-btn-row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 2rem;
  padding: 0 .714rem;
  border-radius: 8px;
  border: 1px solid var(--line);
  background: #fff;
  color: #303030;
  font-size: .786rem;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color .3s ease;
}
.gl-btn-row--ok {
  border-color: #b8e2c8;
  color: var(--green);
}
.gl-btn-row--ok:hover:not(:disabled) {
  background: var(--green);
  border-color: var(--green);
  color: #fff;
}
.gl-btn-row--no {
  border-color: #f3c2bd;
  color: var(--red);
}
.gl-btn-row--no:hover:not(:disabled) {
  background: var(--red);
  border-color: var(--red);
  color: #fff;
}
.gl-btn-row:disabled {
  background: #fafbfc;
  border-color: var(--line);
  color: var(--disabled);
  cursor: not-allowed;
}
.gl-row-actions {
  display: flex;
  gap: 6px;
}
.gl-filter-card {
  background: #fff;
  border: 1px solid var(--line-eee);
  border-radius: 8px;
  padding: 14px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, .06);
}
.gl-filters {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
}
.gl-filters__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.gl-filters__field label {
  color: var(--meta-gray);
  font-size: .786rem;
  font-weight: 600;
  white-space: nowrap;
}
.gl-filters__field input,
.gl-filters__field select {
  height: 34px;
  min-width: 150px;
  padding: 0 10px;
  border: 1px solid var(--line);
  border-radius: 6px;
  font-size: .9rem;
  color: #1f2a2a;
  background: #fff;
}
.gl-filters__field input:focus {
  outline: 2px solid var(--teal-bright);
  outline-offset: 1px;
  border-color: var(--teal-bright);
}
.gl-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  background: #00504b;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background .15s ease;
}
.gl-search-btn:hover {
  background: var(--teal-mid);
}
.gl-link-btn {
  height: 34px;
  background: none;
  border: none;
  padding: 0 4px;
  color: var(--teal-mid);
  font-size: .857rem;
  font-weight: 600;
  cursor: pointer;
}
.gl-link-btn:hover {
  text-decoration: underline;
}
.gl-filters-err {
  margin-top: 10px;
  font-size: .786rem;
  font-weight: 600;
  color: var(--red);
}
.gl-invalid {
  border-color: var(--red) !important;
  background: var(--red-bg) !important;
}
.gl-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.gl-seg {
  display: inline-flex;
  border: 1px solid var(--line);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  align-self: flex-end;
  height: 34px;
}
.gl-seg button {
  border: none;
  border-right: 1px solid var(--line);
  background: #fff;
  padding: 0 .857rem;
  height: 100%;
  font-size: .857rem;
  font-weight: 700;
  color: #303030;
  cursor: pointer;
}
.gl-seg button:last-child {
  border-right: none;
}
.gl-seg button:hover {
  background: var(--teal-pale);
}
.gl-seg button[aria-pressed=true] {
  background: var(--teal-mid);
  color: #fff;
}
.gl-tbl-scroll {
  overflow-x: auto;
}
.gl-table {
  width: 100%;
  border-collapse: collapse;
}
.gl-table th {
  background: #f1f2f5;
  text-align: left;
  padding: 8px 12px;
  font-size: .714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: var(--meta-gray);
  white-space: nowrap;
}
.gl-table td {
  padding: 9px 12px;
  border-bottom: 1px solid var(--line-eee);
  font-size: .929rem;
  vertical-align: top;
}
.gl-table tbody tr:nth-child(even) {
  background: #cff1f04d;
}
.gl-num {
  text-align: right;
  white-space: nowrap;
}
.gl-ctr {
  text-align: center;
}
.gl-nowrap {
  white-space: nowrap;
}
.gl-neg-amt {
  color: var(--red);
  font-weight: 600;
}
.gl-mono {
  font-family: var(--mono-font);
  font-size: .786rem;
  color: #3a3f45;
}
.gl-sub-note {
  display: block;
  font-size: .714rem;
  color: var(--meta-gray);
  font-weight: 400;
  margin-top: 2px;
}
.gl-tag {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 12px;
  font-size: .714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  white-space: nowrap;
}
.gl-tag--blue {
  background: var(--blue-bg);
  color: var(--blue);
  border: 1px solid var(--blue-line);
}
.gl-tag--teal {
  background: #e2f6f4;
  color: var(--teal-mid);
  border: 1px solid #a8e0da;
}
.gl-tag--purple {
  background: var(--lavender-pale);
  color: #5b46a8;
  border: 1px solid #cdc6f2;
}
.gl-tag--green {
  background: var(--green-bg);
  color: var(--green);
  border: 1px solid #b8e2c8;
}
.gl-tag--gray {
  background: #f1f2f5;
  color: var(--meta-gray);
  border: 1px solid var(--line);
}
.gl-freq {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 12px;
  font-size: .643rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  background: var(--teal-pale);
  color: var(--teal-head-text);
  border: 1px solid #a8e0da;
  white-space: nowrap;
}
.gl-freq--replacement {
  background: var(--lavender-pale);
  color: #5b46a8;
  border-color: #cdc6f2;
}
.gl-freq--void {
  background: var(--red-bg);
  color: var(--red);
  border-color: #f3c2bd;
}
.gl-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: .786rem;
  font-weight: 700;
  white-space: nowrap;
}
.gl-pill--ok {
  background: var(--green-bg);
  color: var(--green);
}
.gl-pill--err {
  background: var(--red-bg);
  color: var(--red);
}
.gl-pill--info {
  background: var(--lavender-pale);
  color: #5b46a8;
}
.gl-pill--none {
  background: #f1f2f5;
  color: var(--meta-gray);
}
.gl-empty {
  padding: 24px;
  text-align: center;
  color: var(--meta-gray);
  font-size: .929rem;
  margin: 0;
}
.gl-kv {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 20px;
  padding: 12px;
  background: #fafbfc;
  border: 1px solid var(--line-eee);
  border-radius: 6px;
  margin-bottom: 12px;
}
.gl-kv__k {
  display: block;
  font-size: .714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: var(--meta-gray);
}
.gl-kv__v {
  display: block;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gl-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.gl-field label {
  font-size: .714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: var(--meta-gray);
}
.gl-field textarea {
  min-height: 5rem;
  resize: vertical;
  padding: .429rem .714rem;
  border: 1px solid var(--line);
  border-radius: 8px;
  font-size: .929rem;
  font-family: inherit;
}
.gl-err {
  font-size: .714rem;
  font-weight: 600;
  color: var(--red);
  min-height: 1em;
}
.gl-hint {
  font-size: .786rem;
  color: var(--meta-gray);
  margin: 8px 0 0;
}
:host ::ng-deep button[aria-label="Write Off"].ghost-button {
  width: auto;
  justify-content: center;
  background: #fff;
  border: 1px solid #f3c2bd;
  color: var(--red);
}
:host ::ng-deep button[aria-label="Write Off"].ghost-button:hover:not(:disabled) {
  background: var(--red);
  border-color: var(--red);
  color: #fff;
}
:host ::ng-deep button[aria-label="Write Off"].ghost-button:disabled {
  background: #fafbfc;
  border-color: var(--line-eee);
  color: var(--disabled);
}
/*# sourceMappingURL=global-ledger-list.component-VLJG6CCM.css.map */
